'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _accesibility = require('@marmalade/accesibility');
var _input = require('../input');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var resultStyles = function resultStyles(props) {
  return Object.assign({}, (0, _input.inputStyles)(props), {
    borderRadius: 'none',
    borderTop: 'none',
    padding: '1.4rem 1rem',
    cursor: typeof props.onClick !== 'undefined' ? 'pointer' : undefined
  });
};
var ResultComponent = (0, _glamorous2.default)('div')(resultStyles);
var Result = function (_Component) {
  _inherits(Result, _Component);
  function Result() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, Result);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Result.__proto__ || Object.getPrototypeOf(Result)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
        onClick = _this$props.onClick,
        value = _this$props.value,
        text = _this$props.text;
      (0, _accesibility.Select)(function () {
        return onClick(value, text);
      })(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(Result, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        text = _props.text,
        onClick = _props.onClick,
        rest = _objectWithoutProperties(_props, ['text', 'onClick']);
      var clickProps = typeof onClick !== 'undefined' ? {
        onClick: this.handleClick,
        onKeyDown: this.handleClick
      } : {};
      return _react2.default.createElement(ResultComponent, Object.assign({}, rest, clickProps, {
        role: 'button',
        tabIndex: 0
      }), text);
    }
  }]);
  return Result;
}(_react.Component);
Result.propTypes = {
  value: _propTypes.string,
  text: _propTypes.string,
  onClick: _propTypes.func
};
Result.defaultProps = {
  value: undefined,
  text: undefined,
  onClick: undefined
};
exports.default = Result;